(function ($) {
  Drupal.behaviors.productFindShadeOverlayV1 = {
    attached: false,
    attach: function (context) {
      var self = this;
      var $template = $('.js-product-find-shade-overlay-v1', context);

      if (this.attached) {
        return;
      }
      this.attached = true;

      self.getDom($template);
      self.initOverlay($template);
      self.setEvents($template);
    },
    setEvents: function ($that) {
      var self = this;
      $that.nodes.$triggerTab.off('launch.findShadeTabbed').on('launch.findShadeTabbed', function (event) {
        event.preventDefault();
        $that.nodes.$prodFindShadeOverlay.show().attr('aria-hidden', 'false');
        $('html,body').addClass('find-shade-popup-loaded');
        $(this).trigger('click.findShadeTabbed');
      });
      $that.nodes.$triggerTab.off('click.findShadeTabbed').on('click.findShadeTabbed', function (event) {
        event.preventDefault();
        var tabKeyName = $(this).data('tab-name');

        switchFindShadeTab(tabKeyName);
      }).on('keydown', function (event) {
        var tabKeyName = $(this).data('tab-name');
        if (event.key === "Enter") {
          switchFindShadeTab(tabKeyName);
          $that.nodes.$closeFSOverlay.focus();
        }
      });

      $that.nodes.$closeFSOverlay.once().on('click keydown', function (e) {
        if (e.key === 'Enter' || e.type === 'click') {
          $(document).trigger('findyourshadepopup:close');
        }
      });

      function switchFindShadeTab(tabKeyName) {
        var $activeContent = $that.nodes.$findShadeContent.filter('[data-content-name="'+ tabKeyName +'"]');

        $that.attr('data-current-tab-selected', tabKeyName);
        self.switchFindShadeTabNow($that.nodes.$findShadeContent, $activeContent, $that.nodes.$triggerTab, tabKeyName);
      };
      $(document).on('findyourshadepopup:close', function () {
        if($that.data('currentTabSelected') === 'all_shades') {
          $('.js-filterable-find-shades-block', $that).trigger('filterable_products:allShadeResult');
        }
        $that.nodes.$prodFindShadeOverlay.hide().attr('aria-hidden', 'true');
        $('html,body').removeClass('find-shade-popup-loaded quiz-loaded');
      });
    },
    switchFindShadeTabNow: function ($findShadeContent, $activeContent, $triggerTab, tabKeyName) {
      var $findShadeGridSection = $('.js-filterable-shades-grids-formatter', $findShadeContent);
      // Show this tab content
      $findShadeContent.removeClass('current');
      $activeContent.addClass('current');
      $triggerTab.removeClass('current');
      $triggerTab.filter('[data-tab-name="'+ tabKeyName +'"]').addClass('current');

      if (tabKeyName === 'all_shades' && $findShadeGridSection.length > 0) {
        $findShadeGridSection.trigger('initFindShadeGridOverlay');
      }
      if (tabKeyName === 'take_quiz') {
        $(document).trigger('initFindShadeQuizOverlay');
      }
    },
    getDom: function ($that) {
      $that.nodes = {};
      $that.nodes.$closeFSOverlay = $('.js-product-find-shade-overlay-close', $that);
      $that.nodes.$prodFindShadeOverlay = $that.closest('.js-product-find-shade-content');
      $that.nodes.$triggerTab = $('.js-product-find-shade-overlay-tab:not(.disabled)', $that);
      $that.nodes.$findShadeContent = $('.js-product-find-shade-overlay-content', $that);
    },
    initOverlay: function ($that) {
      if ($that.nodes.$triggerTab.length > 1) {
        $that.addClass('shade-finder-combined');
      }
    }
  };
})(jQuery);
